import React, { useState, useEffect } from 'react';
import PageContent from "../../../components/page-content/page-content";
import { Button, Card, Col, Row, Space, Table, Tag, Select, message, Tabs, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getStocks, copyStocksFromPreviousYear } from "../../../lib/api_stock";
import { getcwcoaAll } from "../../../lib/api_cw_coa";
import Stock_add_modal from "./stock_add_modal";
import Stock_edit_modal from "./stock_edit_modal";
import Stock_package_modal from "./stock_package_modal";
import DictName from "../../../components/dict/dict-name";
import moment from "moment";

const { Column } = Table;
const Stock = () => {
    const [list, setlist] = useState([]);
    const [showStockAddModal, setShowStockAddModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [packageId, setPackageId] = useState(0);
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [selectedType, setSelectedType] = useState(null);
    const [activeTab, setActiveTab] = useState('1');
    const [searchText, setSearchText] = useState('');
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 20,
        },
    });
    const [hasData, setHasData] = useState(false);
    const [copyLoading, setCopyLoading] = useState(false);
    const [coaData, setCoaData] = useState([]);

    // 生成年份选项，从2024年开始到当前年份
    const yearOptions = [];
    const currentYear = moment().year();
    for (let year = 2024; year <= currentYear + 1; year++) {
        yearOptions.push(year);
    }

    const fetchData = () => {
        const type = activeTab === '1' ? 1 : 2;
        getStocks(tableParams.pagination.current, tableParams.pagination.pageSize, selectedYear, type, searchText, sortField, sortOrder)
            .then((res) => {
                if (res.code === 0) {
                    const dataList = res.data.list || [];
                    setlist(dataList);
                    setHasData(dataList.length > 0);
                    setTableParams({
                        ...tableParams,
                        pagination: {
                            ...tableParams.pagination,
                            total: res.data.count || 0,
                        },
                    });
                }
            })
    }

    const fetchCoaData = () => {
        getcwcoaAll(selectedYear)
            .then((res) => {
                if (res.code === 0) {
                    setCoaData(res.data || []);
                }
            })
    }

    useEffect(fetchData, [JSON.stringify(tableParams), selectedYear, activeTab, searchText, sortField, sortOrder]);
    useEffect(fetchCoaData, [selectedYear]);

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.field && sorter.order) {
            setSortField(sorter.field);
            setSortOrder(sorter.order === 'ascend' ? 'asc' : 'desc');
        } else {
            setSortField(null);
            setSortOrder(null);
        }
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const handleCopyFromPreviousYear = () => {
        setCopyLoading(true);
        copyStocksFromPreviousYear(selectedYear)
            .then((res) => {
                if (res.code === 0) {
                    message.success('复制成功');
                    fetchData();
                } else {
                    message.error(res.message || '复制失败');
                }
            })
            .finally(() => {
                setCopyLoading(false);
            });
    };

    const getCoaName = (coaId) => {
        if (!coaId) return '-';
        const coa = coaData.find(item => item.id === coaId);
        let data = [];
        // 增加会员预收款条目
        data.push({ title: "会员预收款", value: 90000000, pid: 0, id: 90000000 });
        data.push({ title: "1 年费", value: 90000001, pid: 90000000, id: 90000001 });
        data.push({ title: "2 寄养费", value: 90000002, pid: 90000000, id: 90000002 });
        data.push({ title: "3 教练费", value: 90000003, pid: 90000000, id: 90000003 });
        data.push({ title: "4 次卡", value: 90000004, pid: 90000000, id: 90000004 });

        if (coa) {
            return coa.name;
        }
        if (data.find(item => item.value === coaId)) {
            return data.find(item => item.value === coaId).title;
        }
        return `未知科目(${coaId})`;
    };

    return (
        <PageContent>
            <Card title={"库存管理"}>
                <Row justify="space-between">
                    <Col>
                        <Space>
                            <span>年份：</span>
                            <Select
                                value={selectedYear}
                                onChange={setSelectedYear}
                                style={{ width: 120 }}
                            >
                                {yearOptions.map(year => (
                                    <Select.Option key={year} value={year}>{year}年</Select.Option>
                                ))}
                            </Select>

                            <span>搜索：</span>
                            <Input.Search
                                placeholder="输入商品名称搜索"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{ width: 200 }}
                                allowClear
                            />
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            {!hasData && selectedYear > 2024 && (
                                <Button
                                    type="primary"
                                    loading={copyLoading}
                                    onClick={handleCopyFromPreviousYear}
                                >
                                    从上一年复制
                                </Button>
                            )}
                            {activeTab === '1' ? (
                                <Button type="primary" icon={<PlusOutlined />}
                                    onClick={() => setShowStockAddModal(true)}>添加库存</Button>
                            ) : (
                                <Button type="primary" icon={<PlusOutlined />}
                                    onClick={() => setPackageId(-1)}>添加组合商品</Button>
                            )}
                        </Space>
                    </Col>
                </Row>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={[
                        {
                            key: '1',
                            label: '普通商品',
                            children: (
                                <Table
                                    dataSource={list}
                                    rowKey={"id"}
                                    pagination={{
                                        ...tableParams.pagination,
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '50', '100'],
                                        showTotal: (total) => `共 ${total} 条`
                                    }}
                                    onChange={handleTableChange}
                                    size={"small"}
                                >
                                    <Column
                                        title="SKU编号"
                                        dataIndex="sku_id"
                                        key="sku_id"
                                        width={80}
                                    />
                                    <Column
                                        title="名称"
                                        dataIndex="name"
                                        key="名称"
                                        sorter={true}
                                    />
                                    <Column
                                        title="分类"
                                        dataIndex="category"
                                        key="分类"
                                        width={100}
                                        render={(category) => <DictName value={category} type_value="stocks_category" />}
                                    />
                                    <Column
                                        title="规格"
                                        dataIndex="specification"
                                        key="规格"
                                        width={120}
                                    />
                                    <Column
                                        title="数量"
                                        dataIndex="quantity"
                                        key="数量"
                                        width={80}
                                        sorter={true}
                                    />
                                    <Column
                                        title="单位"
                                        dataIndex="unit"
                                        key="单位"
                                        width={80}
                                        render={(unit) => <DictName value={unit} type_value="stocks_unit" />}
                                    />
                                    <Column
                                        title="单价"
                                        dataIndex="price"
                                        key="单价"
                                        width={80}
                                        sorter={true}
                                        render={(price) => price ? `¥${price}` : ''}
                                    />
                                    <Column
                                        title="供应商"
                                        dataIndex="supplier"
                                        key="供应商"
                                    />
                                    <Column
                                        title="所属科目"
                                        dataIndex="coa_id"
                                        key="所属科目"
                                        width={180}
                                        render={(coa_id) => getCoaName(coa_id)}
                                    />
                                    <Column
                                        title="操作"
                                        key="操作"
                                        width={80}
                                        render={
                                            (text, record) => (
                                                <Space>
                                                    <a onClick={() => setEditId({ id: record.id, year: record.year })}>编辑</a>
                                                </Space>
                                            )
                                        }
                                    />
                                </Table>
                            ),
                        },
                        {
                            key: '2',
                            label: '组合套餐',
                            children: (
                                <Table
                                    dataSource={list}
                                    rowKey={"id"}
                                    pagination={{
                                        ...tableParams.pagination,
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '50', '100'],
                                        showTotal: (total) => `共 ${total} 条`
                                    }}
                                    onChange={handleTableChange}
                                    size={"small"}
                                >
                                    <Column
                                        title="SKU编号"
                                        dataIndex="sku_id"
                                        key="sku_id"
                                        width={80}
                                    />
                                    <Column
                                        title="名称"
                                        dataIndex="name"
                                        key="名称"
                                        sorter={true}
                                    />
                                    <Column
                                        title="分类"
                                        dataIndex="category"
                                        key="分类"
                                        width={100}
                                        render={(category) => <DictName value={category} type_value="stocks_category" />}
                                    />
                                    <Column
                                        title="规格"
                                        dataIndex="specification"
                                        key="规格"
                                        width={120}
                                    />
                                    <Column
                                        title="数量"
                                        dataIndex="quantity"
                                        key="数量"
                                        width={80}
                                        sorter={true}
                                    />
                                    <Column
                                        title="单位"
                                        dataIndex="unit"
                                        key="单位"
                                        width={80}
                                        render={(unit) => <DictName value={unit} type_value="stocks_unit" />}
                                    />
                                    <Column
                                        title="单价"
                                        dataIndex="price"
                                        key="单价"
                                        width={80}
                                        sorter={true}
                                        render={(price) => price ? `¥${price}` : ''}
                                    />
                                    <Column
                                        title="供应商"
                                        dataIndex="supplier"
                                        key="供应商"
                                    />
                                    <Column
                                        title="所属科目"
                                        dataIndex="coa_id"
                                        key="所属科目"
                                        width={180}
                                        render={(coa_id) => getCoaName(coa_id)}
                                    />
                                    <Column
                                        title="操作"
                                        key="操作"
                                        width={80}
                                        render={
                                            (text, record) => (
                                                <Space>
                                                    <a onClick={() => setPackageId(record.id)}>编辑</a>
                                                </Space>
                                            )
                                        }
                                    />
                                </Table>
                            ),
                        },
                    ]}
                />
            </Card>
            {showStockAddModal &&
                <Stock_add_modal
                    year={selectedYear}
                    onOk={() => {
                        setShowStockAddModal(false);
                        fetchData();
                    }}
                    onCancel={() => {
                        setShowStockAddModal(false);
                    }}
                />
            }

            {editId && editId.id > 0 &&
                <Stock_edit_modal
                    id={editId.id}
                    year={editId.year}
                    onOk={() => {
                        setEditId(null);
                        fetchData();
                    }}
                    onCancel={() => {
                        setEditId(null);
                    }}
                />
            }

            {packageId !== 0 &&
                <Stock_package_modal
                    packageId={packageId}
                    year={selectedYear}
                    onOk={() => {
                        setPackageId(0);
                        fetchData();
                    }}
                    onCancel={() => {
                        setPackageId(0);
                        fetchData();
                    }}
                />
            }
        </PageContent>
    );
}

export default Stock;
